export default __webpack_public_path__ + "static/media/ga.f48f5403.svg";